import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

export function validateDate(c: FormControl, format: string) {
  if (c.value) {
    /* const date = moment(c.value, format, true);

    return date.isValid() ? null : {
      validDate: {
        valid: false
      }
    }; */
    return null;
  } else {
    return null;
  }
}

@Directive({
  selector: '[validDate][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbDateValidator, multi: true}
  ]
})
export class JbDateValidator implements Validator {
  @Input()
  public validDate: string;

  public validate(c: FormControl): ValidationErrors | any {
    return validateDate(c, this.validDate);
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/date.validator.ts